import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { DATEPICKER_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  limit: { label: "Limit", color: "#FFF7ED", textColor: "#C2410C" },
};

const DatePickerList = () => {
  const [rangevalue, setRangeValue] = useState(null);
  const handleDateRangeChange = (value) => {
    console.log(value);
  };

  // Create this utility at the top of your component or in a separate file
  const DateHelper = {
    // Get today's date without time
    today: () => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },

    // Get tomorrow's date
    tomorrow: () => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    },

    // Add days to current date
    addDays: (days) => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    },

    // Strip time from any date
    dateOnly: (date) => {
      if (!date) return null;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },

    // Add months to current date
    addMonths: (months) => {
      const now = new Date();
      return new Date(
        now.getFullYear(),
        now.getMonth() + months,
        now.getDate(),
      );
    },
  };

  return (
    <div>
      <div className="flex flex-col mb-20">
        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Select Date"
              placeholder="Select date"
              type="datepicker"
              defaultOption={"today"}
              onChange={(value) => console.log(value)}
            />
          </div>
          <div>
            <FormFieldSet
              title="Select Date"
              placeholder="Select date"
              type="datepicker"
              disabled
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Select Date and time"
              placeholder="Select date"
              type="datepicker"
              showTime={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Select Date and time"
              placeholder="Select date"
              type="datepicker"
              showTime={true}
              disabled
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Selected"
              type="datepicker"
              placeholder="Select date"
              value={new Date(2025, 1, 10)}
              onChange={(value) => console.log(value)}
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Selected"
              type="datepicker"
              placeholder="Select date"
              value={new Date(2025, 1, 10)}
              onChange={(value) => console.log(value)}
              disabled
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Min Date"
              placeholder="Can not select date before today"
              type="datepicker"
              minDate={DateHelper.today()}
            />
          </div>
          <div>
            <FormFieldSet
              title="Max Date"
              placeholder="Can not select date after today"
              type="datepicker"
              maxDate={DateHelper.today()}
              shadow={true}
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Date Range"
              placeholder="Select date range"
              type="datepickerRange"
              value={rangevalue}
              onChange={(value) => setRangeValue(value)}
              defaultOption={"last month"}
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Range Selected"
              placeholder="Select date range"
              type="datepickerRange"
              value={{
                from: new Date(2025, 1, 10),
                to: new Date(2025, 2, 14),
              }}
              onChange={handleDateRangeChange}
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Range"
              placeholder="Select date range"
              type="datepickerRange"
              disabled
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Range Selected"
              placeholder="Select date range"
              type="datepickerRange"
              value={{
                from: new Date(2025, 1, 10),
                to: new Date(2025, 2, 14),
              }}
              onChange={handleDateRangeChange}
              disabled
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Blocked Dates"
              placeholder="Select date range"
              type="datepickerRange"
              value={{
                from: new Date(2025, 10, 15),
                to: new Date(2025, 11, 14),
              }}
              onChange={handleDateRangeChange}
              blockDates={[
                { from: "2025-11-18", to: "2025-11-20" },
                { from: new Date(2025, 10, 25), to: new Date(2025, 10, 28) },
                new Date(2025, 11, 5),
              ]}
            />
          </div>
          <div>
            <FormFieldSet
              title="Blocked Date"
              placeholder="Select date range"
              type="datepicker"
              value={new Date(2025, 10, 16)}
              onChange={handleDateRangeChange}
              blockDates={[new Date(2025, 10, 25)]}
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Date Range with no Dropdown"
              placeholder="Select date range"
              type="datepicker"
              value={new Date(2025, 1, 10)}
              showDropdown={false}
            />
          </div>
          <div>
            <FormFieldSet
              title="Date Range Selected with no Dropdown"
              placeholder="Select date range"
              type="datepickerRange"
              value={{
                from: new Date(2025, 1, 10),
                to: new Date(2025, 2, 14),
              }}
              onChange={handleDateRangeChange}
              shadow={true}
              showDropdown={false}
            />
          </div>
        </div>
      </div>

      <PropsTable
        data={DATEPICKER_PROPS}
        title="datepicker || datepickerRange — Props Reference"
        typeLabel='type="datepicker || datepickerRange"'
        categories={CATEGORIES}
      />
    </div>
  );
};

export default DatePickerList;
